import { defineChannelContract } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { FailableUserDto, UserWithPermissionsInDto } from 'shared/domain/user/types/inDto';
import type { CurrentUserIdentity } from './currentUserIdentity';
import type { SuperadminUserUpdateDto, UserPersonalDataUpdateDto } from 'shared/domain/user/types/outDto';

/** The logged-in user with permissions in all organizations and projects. */
export interface CurrentUserData {
  userData: UserWithPermissionsInDto;
}

/** The logged-in user's own label and phone in one organization. */
export interface PersonalDataChange {
  userId: string;
  organizationId: string;
  personalData: UserPersonalDataUpdateDto;
}

/**
 * The logged-in user, served by the service worker: it downloads the user
 * on request (and with its permission pulls, broadcasting the permissions)
 * and saves the user's own data.
 */
export const currentUserContract = defineChannelContract<{
  requests: {
    /** Downloads the user now; the worker applies its permissions. */
    refresh: { request: undefined; response: UserWithPermissionsInDto };
    updatePersonalData: { request: PersonalDataChange; response: FailableUserDto };
    updateSuperadminLabel: { request: SuperadminUserUpdateDto; response: FailableUserDto };
    /** The logged-in user the page knows, so the worker's logs name them before it downloads them. */
    identify: { request: CurrentUserIdentity; response: void };
  };
  events: {
    [DomainMessagesTypes.currentUserPermissions]: CurrentUserData;
  };
}>('currentUserChannel');
